import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Feyza Kantarcı — kişisel iletişim sayfası.
 *
 * 15.09.2026'da istendi: adres verildi (`/about/team/feyza-kantarci`, o güne
 * kadar 404'tü) ve sayfanın taşıması gereken üç bilgi verildi — adı, cep
 * telefonu ve iş e-postası. Başka bir bilgi verilmediği için başka bir şey
 * yazılmadı; sayfa, onun adına yazılmış bir biyografi değil, iki iletişim yolu
 * ve altında sitenin kendi iletişim bandı.
 *
 * 15.09.2026'da ekip iletişim sayfalarının birbiriyle bütünlüklü olması istendi:
 * ortalanmış isim, kart başlığının doğrudan adres ya da numara olduğu bir
 * `features` grid'i ve sonda diğer kartlarla aynı iletişim bandı.
 */
const EMAIL = 'feyza@digitopia.ai'
const PHONE_DISPLAY = '+90 541 472 58 75'
const PHONE_DIAL = 'tel:+905414725875'

export const teamFeyzaKantarci: WrittenPage = {
  navLabel: 'Feyza Kantarcı',
  title: 'Feyza Kantarcı',
  description:
    'Digitopia’dan Feyza Kantarcı ile iletişime geçin: feyza@digitopia.ai veya +90 541 472 58 75.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Digitopia',
      headline: 'Feyza Kantarcı',
      align: 'center',
      ctas: [
        { label: 'E-posta', href: `mailto:${EMAIL}` },
        { label: 'Ara', href: PHONE_DIAL },
        // 17.09.2026: telefona doğrudan kaydetmek için vCard. Dosya
        // `public/vcf/` içinde, sayfanın slug'ıyla aynı adda.
        { label: 'Rehbere kaydet', href: '/vcf/feyza-kantarci.vcf' },
      ],
    },
    {
      kind: 'features',
      heading: 'İletişim',
      columns: 2,
      items: [
        {
          title: EMAIL,
          note: 'E-posta',
          href: `mailto:${EMAIL}`,
        },
        {
          title: PHONE_DISPLAY,
          note: 'Türkiye',
          href: PHONE_DIAL,
        },
      ],
    },
    {
      kind: 'cta',
      heading: 'Kişi yerine firmayla mı başlamak istersiniz?',
      sub: 'İletişim formu tüm ekibe ulaşır; Hakkımızda ise birlikte çalışacağınız diğer isimleri anlatır.',
      tone: 'band',
      ctas: [
        { label: 'Digitopia ile iletişime geçin', href: LINKS.contact },
        { label: 'Hakkımızda', href: LINKS.about },
      ],
    },
  ],
}
